import { render, staticRenderFns } from "./Computadores.vue?vue&type=template&id=dfff441a&scoped=true"
import script from "./Computadores.vue?vue&type=script&lang=js"
export * from "./Computadores.vue?vue&type=script&lang=js"
import style0 from "./Computadores.vue?vue&type=style&index=0&id=dfff441a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfff441a",
  null
  
)

export default component.exports